<script lang="ts">
  import { link } from "svelte-spa-router";
  import active from "svelte-spa-router/active";
  import ChevronDown from "../icons/ChevronDown.svelte";
  import ChevronUp from "../icons/ChevronUp.svelte";
  import TextNew from "../TextNew.svelte";
  import { track } from "../../helpers/mixpanel";

  export let sidePanelExpanded: boolean;
  export let href: string;
  export let text: string;
  export let selected: boolean;
  export let hasSubmenu = false;
  export let expandSubmenu = false;

  // styles related
  export let color = "";

  function toggleSubmenu() {
    expandSubmenu = !expandSubmenu;
  }

  let linkCss = "";
  if (color) {
    linkCss += `color: ${color}; opacity: 1;`;
  }

  $: isSidePanelExpanded = sidePanelExpanded;
  $: isExpanded = expandSubmenu;

  const trackingKeysByHref: Record<string, string> = {
    "/prices": "nav_price_history_click",
    "/invoices": "nav_invoices_click",
    "/integrations": "nav_integrations_click",
    "/stock-take": "nav_stock_take_click",
    "/spend-report": "nav_overview_click",
  };

  function handleLinkClick() {
    const key = trackingKeysByHref[href];
    if (!key) {
      return;
    }
    track(trackingKeysByHref[href]);
  }
</script>

<div class="container">
  <a
    class={`link ${!isSidePanelExpanded && "just-link"}`}
    class:selected
    {href}
    style={linkCss}
    use:link
    use:active
    on:click={handleLinkClick}
  >
    <slot name="icon" />
    {#if sidePanelExpanded}
      <TextNew size="s" weight="medium">{text}</TextNew>
    {/if}
  </a>
  {#if hasSubmenu && isSidePanelExpanded}
    <button class="expand-link" on:click={toggleSubmenu}>
      {#if isExpanded}
        <ChevronUp />
      {:else}
        <ChevronDown />
      {/if}
    </button>
  {/if}
</div>
{#if isExpanded && isSidePanelExpanded}
  <slot name="submenu" />
{/if}

<style>
  .container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  button {
    background: none;
    outline: none;
    border: none;
    color: var(--rekki-dark);
    opacity: 0.6;
  }
  button:hover {
    opacity: 1;
  }

  .link {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    color: var(--rekki-dark);
    opacity: 0.6;
    text-decoration: none;
    margin-left: 8px;
  }
  .link.just-link {
    justify-content: center;
    margin-left: 0;
  }

  .link:hover {
    opacity: 1;
  }

  .text {
    margin-left: 16px;
  }

  .selected {
    color: #150e0b;
    opacity: 1;
  }
</style>
